// Form error helpers: count problems per visible field, not per raw error key
// (address parts all belong to "location", date/time parts to "date").
const GROUP = (key) => {
  const k = key.replace(/^extraDates\[\d+\]\./, "");
  if (["location", "address", "venueName", "streetAddress", "unit", "city", "state", "zipCode", "street", "zip", "postalCode", "country"].includes(k)) return "location";
  if (["date", "startDate", "startTime", "endTime", "repeatEndsOnDate"].includes(k)) return "date";
  return k.split(".")[0];
};

const messageOf = (v) => (typeof v === "string" ? v : v?.error);

// "please add a title" when one field is wrong, "3 fields need attention" otherwise
export const errorSummary = (errors = {}) => {
  const groups = new Map();
  Object.entries(errors).forEach(([key, value]) => {
    const msg = messageOf(value);
    if (msg && !groups.has(GROUP(key))) groups.set(GROUP(key), msg);
  });
  if (groups.size === 0) return null;
  return groups.size === 1 ? [...groups.values()][0] : `${groups.size} fields need attention`;
};
